import { Injectable } from '@angular/core';

@Injectable()
export class EmploymentTransportModeDto {
  constructor(
    public readonly id: number,
    public readonly description: string,
    public readonly transportModeId: number,
    public readonly beneficiaryEmploymentId?: number,
  ) {}

  public static fromJson(json: any): EmploymentTransportModeDto {
    if (json) {
      return new EmploymentTransportModeDto(json.id, json.description, json.transportModeId, json.beneficiaryEmploymentId);
    }
  }
}
